import React, { useState } from 'react';
import PageBanner from '../components/PageBanner';
import { FAQS } from '../data/mock';
import { Plus, Minus } from 'lucide-react';
import CTASection from '../components/CTASection';

const FAQs = () => {
  const [open, setOpen] = useState(0);

  return (
    <main>
      <PageBanner title="Frequently Asked Questions" crumb="FAQs" />
      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <div className="text-center mb-12">
            <p className="uppercase text-sm tracking-[0.25em] text-slate-500 mb-3">Got Questions?</p>
            <h2 className="heading-display text-4xl md:text-5xl font-bold text-slate-900">We have answers</h2>
          </div>
          <div className="space-y-3">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className={`border ${isOpen ? 'border-[#F97559]' : 'border-slate-200'} rounded-sm transition-colors`}>
                  <button onClick={() => setOpen(isOpen ? -1 : i)} className="w-full flex items-center justify-between gap-4 p-5 text-left">
                    <span className={`heading-display font-semibold text-base md:text-lg ${isOpen ? 'text-[#F97559]' : 'text-slate-900'}`}>{f.q}</span>
                    <span className={`shrink-0 w-9 h-9 rounded-full grid place-items-center transition-colors ${isOpen ? 'bg-[#F97559] text-white' : 'bg-slate-100 text-slate-700'}`}>
                      {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-slate-600 leading-7 text-[14.5px]">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <CTASection />
    </main>
  );
};

export default FAQs;
